import Vue from 'vue'
import instruction_title_screen from './instructions_title_screen.vue'
import instructions_header_image from './instructions_header_image.vue'
import instructions_header_image_two_button from './instructions_header_image_two_button/instructions_header_image_two_button.vue'
import instructions_text_only from './instructions_text_only.vue'
import instructions_header_image_one_button from './instructions_header_image_one_button.vue'
import image_series_5 from './image_series_5.vue'
import small_center_image from './small_center_image.vue'
import two_part_image_one_button from './two_part_image_one_button.vue'
import button_sequence from './button_sequence/button_sequence.vue'
import one_image_one_label_two_buttons from './one_image_one_label.vue'
import two_images_two_buttons_with_legend from './two_images_two_buttons_with_legend.vue'

import exam_flanker from './exams/exam_flanker.vue'
import exam_go_no_go from './exams/exam_go_no_go.vue'
import exam_trails from './exams/exam_trails.vue'
import exam_paired_association from './exams/exam_paired_association.vue'
import exam_processing_speed from './exams/exam_processing_speed.vue'

import exam_imprint_memory_assessment from './exams/exam_image_pairs.vue'
import two_images_horizontal from './two_images_horizontal.vue'

import blank from './blank.vue'

const instructions_title_screen = instruction_title_screen
const button_sequence_with_header = button_sequence
const one_image_one_label_horizontal = one_image_one_label_two_buttons
const two_images_horizontal_two_buttons = two_images_horizontal

export const components = {
  // imports all components related to ESSContainer
  instruction_title_screen,
  instructions_header_image,
  instructions_header_image_two_button,
  instructions_text_only,
  instructions_header_image_one_button,
  image_series_5,
  instructions_title_screen,
  small_center_image,
  two_part_image_one_button,
  button_sequence,
  button_sequence_with_header,
  one_image_one_label_two_buttons,
  one_image_one_label_horizontal,
  two_images_two_buttons_with_legend,

  exam_flanker,
  exam_go_no_go,
  exam_trails,
  exam_paired_association,
  exam_processing_speed,

  exam_imprint_memory_assessment,
  two_images_horizontal,
  two_images_horizontal_two_buttons,
  blank
}

Object.entries(components).forEach(([name, component]) => Vue.component(name, component))
